import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=ef78ed04&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=ef78ed04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef78ed04",
  null
  
)

export default component.exports